/* eslint react/forbid-prop-types: 0, react/no-unused-prop-types: 0 */
/* global globals, translations */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PaymentsStore from '../../stores/PaymentsStore';

const SubscriptionBlocks = (props) => {
  const { termsData, chosenOption } = props;
  const [showPremiumPopup, setShowPremiumPopup] = useState(false);

  // Add effect to handle vex-open class on body
  useEffect(() => {
    if (showPremiumPopup) {
      document.body.classList.add('vex-open');
    } else {
      document.body.classList.remove('vex-open');
    }
    return () => {
      document.body.classList.remove('vex-open');
    };
  }, [showPremiumPopup]);

  // console.log(termsData);

  // Sort payment types into SMS and regular groups, then sort by term length
  const paymentTypes = Object.keys(termsData)
    .filter((item) => Number(item))
    .sort((a, b) => Number(a) - Number(b)) // Sort by term length
    .sort((a, b) => {
      // Sort SMS types first
      const aIsSms = termsData[a].type === 'sms';
      const bIsSms = termsData[b].type === 'sms';
      if (aIsSms && !bIsSms) return -1;
      if (!aIsSms && bIsSms) return 1;
      return 0;
    });

  // add vip to the end of the array
  if (termsData.vip) {
    paymentTypes.push('vip');
  }

  const result = [];

  const keyBase = 'subscription_block_key_base_';
  let counter = 1;


  const vipBadge = (
    <div className="paymentPeriod-premium paymentPeriod-badge-premium">
      <div className="paymentPeriod-badgeText">
        <span className="badgeText-title">{get(translations, 'txt: Premium', 'Premium')}</span>
        <span className="badgeText-subtitle">{get(translations, 'txt: abonements', 'abonements')}</span>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowPremiumPopup(true);
          }}
        >
          {get(translations, 'txt: Kā tas darbojas?', 'Kā tas darbojas?')}
        </a>
      </div>
    </div>
  )


  paymentTypes.forEach((payment, index) => {
    const termData = termsData[payment];

    let badge = '';
    if (termData.badge) {
      switch (termData.badge) {
        case 'most-popular':
          badge = (
            <div className="paymentPeriod-badge paymentPeriod-badge--popular">
              <div className="paymentPeriod-badgeText">
                {get(translations, 'txt: populārākais', 'populārākais')}
              </div>
            </div>
          );
          break;
        case 'best-value':
          badge = (
            <div className="paymentPeriod-badge paymentPeriod-badge--bestvalue">
              <div className="paymentPeriod-badgeText">
                {get(translations, 'txt: izdevīgāk', 'izdevīgākais')}
              </div>
            </div>
          );
          break;
        case 'suggested':
            badge = (
              <div className="paymentPeriod-badge paymentPeriod-badge--suggested">
                <div className="paymentPeriod-badgeText">
                  {get(translations, 'txt: iesakām', 'iesakām')}
                </div>
              </div>
            );
            break;
        case 'discount':
          badge = (
            <>
              <div className="paymentPeriod-badge paymentPeriod-badge--savings">
                <div className="paymentPeriod-badgeText">
                  {`- ${termData.campaign.discount}`}
                </div>
              </div>
              {payment === 'vip' && vipBadge}
            </>
          );
          break;
        case 'vip':
          badge = vipBadge;
          break;
        default:
          badge = '';
      }
    }

    const paymentPeriodTime = (
      <div className="paymentPeriod-time">
        <div className="paymentPeriod-timeTitle">
          {termData.title}
          <span className="paymentPeriod-subtitle">
            {termData.subtitle}
          </span>
        </div>
      </div>
    );

    let paymentPeriodPriceClassName = 'paymentPeriod-price';
    let paymentPeriodPriceTitle = (
      <div className="paymentPeriod-priceTitle">
        {termData.amountToPay.toFixed(2)}
        <span className="paymentPeriod-subtitle pls">
          {get(globals, 'currency', '')}
        </span>
      </div>
    );

    if (termData.campaign) {
      paymentPeriodPriceClassName += ' paymentPeriod-price--special';
      paymentPeriodPriceTitle = (
        <div className="paymentPeriod-priceTitle">
          <span className="tcr">
            {termData.campaign.amountToPay.toFixed(2)}
          </span>
          <span className="paymentPeriod-subtitle pls">
            {get(globals, 'currency', '')}
            <p className="paymentPeriod-subtitle tdlt">
              {`${termData.amountToPay.toFixed(2)} ${get(globals, 'currency', '')}`}
            </p>
          </span>
        </div>
      );
    }

    const paymentPeriodPrice = (
      <div className={paymentPeriodPriceClassName}>
        {paymentPeriodPriceTitle}
      </div>
    );

    const paymentPeriodConfirm = (
      <button type="button" className="btn btn--b btn--iconLeft paymentPeriod-confirm">
        <span>{get(translations, 'txt: Izvēlēties', 'Izvēlēties')}</span>
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <svg className="icon icon--check-1">
                <use xlinkHref="#icon-check-1" />
              </svg>
            </span>
          </span>
        </span>
      </button>
    );

    const paymentPeriodSelected = (
      <span className="paymentPeriod-selected">
        <svg className="icon icon--full icon--check-2">
          <use xlinkHref="#icon-check-2" />
        </svg>
      </span>
    );

    let paymentPeriodClassName = 'paymentPeriod';
    let seperator = null;
    if (termData.type === 'sms') {
      paymentPeriodClassName += ' paymentPeriod--sms';
      seperator = <span className="paymentPeriod-separator" key={keyBase + counter} />;
      counter += 1;
    }
    if (termData.badge === 'vip' || payment === 'vip') {
      paymentPeriodClassName += ' paymentPeriod--premium';
    }
    if (chosenOption && chosenOption === payment) {
      paymentPeriodClassName += ' is-active';
    }
    if (index < paymentTypes.length - 1) {
      paymentPeriodClassName += ' mrm';
    }

    const readyResult = (
      <div
        role="button"
        className={paymentPeriodClassName}
        onClick={() => { PaymentsStore.setActive(payment); }}
        onKeyDown={() => { PaymentsStore.setActive(payment); }}
        tabIndex={counter}
        key={keyBase + counter}
      >
        {badge}
        {paymentPeriodTime}
        {paymentPeriodPrice}
        {paymentPeriodConfirm}
        {paymentPeriodSelected}
      </div>
    );

    result.push(readyResult);

    if (seperator) {
      result.push(seperator);
    }

    counter += 1;
  });

  // Update PremiumFeaturesPopup to use vex classes
  const PremiumFeaturesPopup = () => (
    <div className="vex vex-theme-default">
      <div className="vex-overlay" onClick={() => setShowPremiumPopup(false)}></div>
      <div className="vex-content" style={{ width: '600px', maxWidth: '100%', textAlign: 'left' }}>
        <div className="vex-close" onClick={() => setShowPremiumPopup(false)}>
        </div>
        <h3>{get(translations, 'txt: Premium abonements', 'Premium abonements')}</h3>
        <p>{get(translations, 'txt: Premium abonementam ir pieejami divi papildus iestatījumi', 'Premium abonementam ir pieejami divi papildus iestatījumi pēc izvēles')}:</p>
        <ul>
          <li>{get(translations, 'txt: Iespēja uz sava profila foto rādīt Premium lietotāja ikonu', 'Iespēja uz sava profila foto rādīt Premium lietotāja ikonu, lai citi lietotāji redzētu, ka tavi nodomi ir nopietni.')}</li>
          <li>{get(translations, 'txt: Iespēja platformu lietot anonīmi', 'Iespēja platformu lietot anonīmi, lai citi lietotāji neredzētu tavas darbības savā statistikā.')}</li>
        </ul>
        <p>{get(translations, 'txt: Iegādājoties Premium abonementu, šos iestatījumus iespējams brīvi mainīt', 'Iegādājoties Premium abonementu, šos iestatījumus iespējams brīvi mainīt.')}</p>
      </div>
    </div>
  );

  return (
    <>
      <div className="paymentPeriod-container">
        {result}
      </div>
      {showPremiumPopup && <PremiumFeaturesPopup />}
    </>
  );
};

SubscriptionBlocks.propTypes = {
  termsData: PropTypes.instanceOf(Object).isRequired,
  chosenOption: PropTypes.string,
};
SubscriptionBlocks.defaultProps = {
  chosenOption: null,
};

export default SubscriptionBlocks;
